"use client"

import React, { useEffect } from "react"
import { SEARCH_PARAMS_PAGE_VIEW_OPTIONS, SearchArticleViewOptions } from "@/constants/ui"
import { useUbStorefrontState } from "@/store/ubStorefrontState"
import * as ToggleGroup from "@radix-ui/react-toggle-group"
import { ClassValue } from "clsx"
import { LayoutGridIcon, LayoutListIcon } from "lucide-react"
import { useTranslations } from "next-intl"

import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/components/tooltip"
import { cn } from "@/components/ui/helpers/utils"

export default function SearchResultArticleView(props: {
  defaultView?: SearchArticleViewOptions
  className?: ClassValue
}) {
  const t = useTranslations("storefront")
  const { articleListView, setArticleListView } = useUbStorefrontState()

  useEffect(() => {
    props.defaultView != undefined && setArticleListView(props.defaultView)
  }, [props.defaultView, setArticleListView])

  return (
    <>
      <ToggleGroup.Root
        type={"single"}
        value={articleListView}
        onValueChange={setArticleListView}
        className={cn("inline-flex h-10 w-fit rounded-sm border border-gray-300 bg-white", props.className)}
      >
        {SEARCH_PARAMS_PAGE_VIEW_OPTIONS.map((option) => (
          <Tooltip key={option}>
            <ToggleGroup.Item
              value={option}
              disabled={articleListView === option}
              aria-label={t("article_view.option_" + option)}
              className={
                "border-r border-gray-100 p-2 first:rounded-l-sm last:rounded-r-sm last:border-r-0 hover:bg-primary-hover hover:text-white data-[state=on]:bg-primary data-[state=on]:text-white"
              }
            >
              <TooltipTrigger asChild={true}>
                {option == SEARCH_PARAMS_PAGE_VIEW_OPTIONS[0] ? (
                  <LayoutGridIcon className={"size-5"} strokeWidth={1.5} />
                ) : (
                  <LayoutListIcon className={"size-5"} strokeWidth={1.5} />
                )}
              </TooltipTrigger>
            </ToggleGroup.Item>
            <TooltipContent>{t("article_view.option_" + option)}</TooltipContent>
          </Tooltip>
        ))}
      </ToggleGroup.Root>
    </>
  )
}
